
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model } from '../../controlador';
    import { Situacion } from '@/__env/lib/Pantalla/Situacion';
    import { Empresa } from '@/__env/lib/MercadoLibre/Cuentas/Cuentas';
    import moment from 'moment';
    import { EstadisticaVentas, Cliente } from '@/__env/lib/Clientes';
    import { WaitEntre } from '@/__env/ext';
import { FavoritosPantalla } from '@/__env/lib/Pantalla/Favoritos';
    @Component( {
        name: "Componente",
        props: {},
        components: {
        }
    } )
    export default class Componente extends Vue
    {
        public get Controlador() { return Model; }

        @Prop()
        public Item: EstadisticaVentas;

        @Prop()
        public Posicion: number;


        protected Eventos: Function[] = [];
        beforeDestroy()
        {

            this.Eventos.forEach( x => x() );
        }

        async mounted()
        {
            this.Eventos.push( this.Controlador.onActualizarFavoritos.subscribe( () => this.Refrescar() ) );
        }


        public Seleccionar( x: Cliente )
        {
            this.Controlador.ClienteSeleccionado = x;
            this.Controlador.Vista.Modo = 'cliente';
        }

        public Refresh: boolean = true;
        public Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => { this.Refresh = true; } );
        }
    }
